var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seo_10701004 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50-SEO copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.668 18.2383C44.5395 18.2383 42.4588 18.8694 40.6891 20.052C38.9193 21.2345 37.54 22.9152 36.7254 24.8817C35.9109 26.8481 35.6978 29.0119 36.113 31.0995C36.5283 33.1871 37.5532 35.1046 39.0583 36.6097C40.5633 38.1147 42.4809 39.1397 44.5685 39.5549C46.656 39.9702 48.8199 39.7571 50.7863 38.9425C52.7527 38.128 54.4335 36.7486 55.616 34.9789C56.7985 33.2091 57.4297 31.1285 57.4297 29C57.4297 26.1458 56.2959 23.4085 54.2777 21.3903C52.2594 19.3721 49.5222 18.2383 46.668 18.2383ZM46.668 35.6224C45.3582 35.6224 44.0778 35.234 42.9888 34.5063C41.8997 33.7787 41.0509 32.7444 40.5497 31.5343C40.0484 30.3242 39.9173 28.9927 40.1728 27.708C40.4283 26.4234 41.0591 25.2434 41.9852 24.3172C42.9114 23.3911 44.0914 22.7604 45.376 22.5048C46.6606 22.2493 47.9922 22.3804 49.2023 22.8817C50.4124 23.3829 51.4466 24.2317 52.1743 25.3208C52.902 26.4098 53.2904 27.6902 53.2904 29C53.2886 30.7558 52.5903 32.4392 51.3487 33.6808C50.1072 34.9223 48.4238 35.6206 46.668 35.6224Z",
    fill: "#EA4235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9853 29.461C12.4635 28.9897 11.8839 28.5868 11.2603 28.262L6.41982 25.7167C6.10798 25.556 5.81778 25.3564 5.55616 25.1227C5.14937 24.752 5.98425 22.9759 7.34861 22.7695C8.21374 22.6393 10.3748 22.5923 11.7636 24.9715L15.2891 22.5917C13.4275 19.4026 10.2417 17.8124 6.76963 18.3369C3.87711 18.7738 1.59778 20.5821 0.962723 22.9438C0.432566 24.9149 1.12641 26.9548 2.86585 28.5391C3.38762 29.0103 3.96721 29.4131 4.59067 29.738L9.43242 32.2835C9.74411 32.4441 10.0342 32.6436 10.2957 32.8772C10.702 33.2481 9.86731 35.0241 8.50352 35.2305C7.63873 35.361 5.47732 35.4078 4.08849 33.0285L0.5625 35.4083C2.09372 38.0314 4.52032 39.573 7.26614 39.7455C7.87258 39.7826 8.48124 39.7549 9.08182 39.6631C11.9745 39.2261 14.2537 37.4179 14.8887 35.0563C15.4189 33.0846 14.7251 31.0452 12.9853 29.461Z",
    fill: "#4385F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.8047 22.5078V26.4727H32.2812V31.0039H24.8047V34.9687H32.2812V39.5H19.8203V17.9766H32.2812V22.5078H24.8047Z",
    fill: "#FABC05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo2);
export default __webpack_public_path__ + "static/media/seo2.7c34953820791a8f119f2af0d01b23f7.svg";
export { ForwardRef as ReactComponent };